import { initDetectDropdownPositions } from './src/buttonDropdown.js';
import { initCollapsible } from './src/collapsible.js';
import { initConfirmable } from './src/confirmable.js';
import { initDetectFormChanges } from './src/detectFormChanges.js';
import { initDatepicker } from './src/flatpickr.js';
import { initFileInput } from './src/form.js';
import { initFormSubmitInterfere } from './src/formSubmitInterfere.js';
import { initLiveSearch } from './src/liveSearch.js';
import { initModal } from './src/modal.js';
import { initNotification } from './src/notifications.js';
import { initSidebar } from './src/sidebar.js';
import { initSortable } from './src/sortable.js';

export function initAll(config = {}, target = null) {
  const { flatpickr, formSubmitInterfere, sidebar } = config;
  initCollapsible(target);
  initConfirmable(target);
  initDetectFormChanges(target);
  initDatepicker(flatpickr, target);
  initFileInput(target);
  initFormSubmitInterfere(formSubmitInterfere, target);
  initLiveSearch(target);
  initModal(target);
  initNotification(target);
  initSidebar(sidebar);
  initSortable(target);
  initDetectDropdownPositions(target);
}

export {
  initCollapsible,
  initConfirmable,
  initDatepicker,
  initDetectDropdownPositions,
  initDetectFormChanges,
  initFileInput,
  initFormSubmitInterfere,
  initLiveSearch,
  initModal,
  initNotification,
  initSidebar,
  initSortable,
};
